import dataCenter from "../../api/dataCenter";
import request from "@/helpers/request";

const state = {
    teachingDataList: {},
    teachingDataListLoading: false,
    teachingDataListFilter: {},

    dataTestInfoList: {},
    dataTestInfoListLoading: false,

    dataMarkInfoList: {},
    dataMarkInfoListLoading: false,

    studentDataList: {},
    studentDataListFilter: {},
    studentDataListLoading: false,
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.teachingDataListFilter = {};
        state.studentDataListFilter = {};
    },
};
const actions = {
    async getAnalyseData({commit}, payload) {
        return await dataCenter.getAnalyseData(payload);
    },
    async exportTraineeData({commit}, payload) {
        return await dataCenter.exportTraineeData(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTeachingDataList({commit}, payload) {
        commit("setData", {key: "teachingDataListLoading", value: true});
        const payloads = {
            ...payload,
        };
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                size: state.teachingDataList.size,
                ...state.teachingDataListFilter,
                ...payloads,
            };
            const res = await dataCenter.getTeachingDataList.getList(params);
            commit("setData", {key: "teachingDataList", value: res.data});
        } finally {
            commit("setData", {key: "teachingDataListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getDataUserInfoList({commit}, payload) {
        commit("setData", {key: "studentDataListLoading", value: true});
        const payloads = {
            ...payload,
        };
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                size: state.studentDataList.size,
                ...state.studentDataListFilter,
                ...payloads,
            };
            const res = await dataCenter.getDataUserInfo.getList(params);
            commit("setData", {key: "studentDataList", value: res.data});
        } finally {
            commit("setData", {key: "studentDataListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getDataTestInfo({commit}, payload) {
        commit("setData", {key: "dataTestInfoListLoading", value: true});
        const res = await dataCenter.getDataTestInfo(payload);
        commit("setData", {key: "dataTestInfoList", value: res});
        commit("setData", {key: "dataTestInfoListLoading", value: false});
    },
    // eslint-disable-next-line no-empty-pattern
    async getDataMarkInfo({commit}, payload) {
        commit("setData", {key: "dataMarkInfoListLoading", value: true});
        const res = await dataCenter.getDataMarkInfo(payload);
        commit("setData", {key: "dataMarkInfoList", value: res});
        commit("setData", {key: "dataMarkInfoListLoading", value: false});
    },
    // eslint-disable-next-line no-empty-pattern
    async exportDataUserInfo({}) {
        await dataCenter.exportDataUserInfo();
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
